import { render, staticRenderFns } from "./storeBind.vue?vue&type=template&id=a6836670&scoped=true"
import script from "./storeBind.vue?vue&type=script&lang=js"
export * from "./storeBind.vue?vue&type=script&lang=js"
import style0 from "./storeBind.vue?vue&type=style&index=0&id=a6836670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6836670",
  null
  
)

export default component.exports